// extracted by css-extract-rspack-plugin
module.exports =  {"root":"OpportunitiesListEmpty__root___jlj1K"};